function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestyleediting
 */
import { Plugin } from 'ckeditor5/src/core';
import ImageStyleCommand from './imagestylecommand';
import ImageUtils from '../imageutils';
import utils from './utils';
import { viewToModelStyleAttribute, modelToViewStyleAttribute } from './converters';
/**
 * The image style engine plugin. It sets the default configuration, creates converters and registers
 * {@link module:image/imagestyle/imagestylecommand~ImageStyleCommand ImageStyleCommand}.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageStyleEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageStyleEditing, _Plugin);

  var _super = _createSuper(ImageStyleEditing);

  function ImageStyleEditing() {
    _classCallCheck(this, ImageStyleEditing);

    return _super.apply(this, arguments);
  }

  _createClass(ImageStyleEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var normalizeStyles = utils.normalizeStyles,
          getDefaultStylesConfiguration = utils.getDefaultStylesConfiguration;
      var editor = this.editor;
      var isBlockPluginLoaded = editor.plugins.has('ImageBlockEditing');
      var isInlinePluginLoaded = editor.plugins.has('ImageInlineEditing');
      editor.config.define('image.styles', getDefaultStylesConfiguration(isBlockPluginLoaded, isInlinePluginLoaded));
      /**
       * It contains a list of the normalized and validated style options.
       *
       * * Each option contains a complete icon markup.
       * * The style options not supported by any of the loaded image editing plugins (
       * {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`} or
       * {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`}) are filtered out.
       *
       * @protected
       * @readonly
       * @type {module:image/imagestyle~ImageStyleConfig}
       */

      this.normalizedStyles = normalizeStyles({
        configuredStyles: editor.config.get('image.styles'),
        isBlockPluginLoaded: isBlockPluginLoaded,
        isInlinePluginLoaded: isInlinePluginLoaded
      });

      this._setupConversion(isBlockPluginLoaded, isInlinePluginLoaded);

      this._setupPostFixer(); // Register imageStyle command.


      editor.commands.add('imageStyle', new ImageStyleCommand(editor, this.normalizedStyles));
    }
    /**
     * Sets the editor conversion taking the presence of
     * {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`}
     * and {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`} plugins into consideration.
     *
     * @private
     * @param {Boolean} isBlockPluginLoaded
     * @param {Boolean} isInlinePluginLoaded
     */

  }, {
    key: "_setupConversion",
    value: function _setupConversion(isBlockPluginLoaded, isInlinePluginLoaded) {
      var editor = this.editor;
      var schema = editor.model.schema;
      var modelToViewConverter = modelToViewStyleAttribute(this.normalizedStyles);
      var viewToModelConverter = viewToModelStyleAttribute(this.normalizedStyles);
      editor.editing.downcastDispatcher.on('attribute:imageStyle', modelToViewConverter);
      editor.data.downcastDispatcher.on('attribute:imageStyle', modelToViewConverter); // Allow imageStyle attribute in image and imageInline.
      // We could call it 'style' but https://github.com/ckeditor/ckeditor5-engine/issues/559.

      if (isBlockPluginLoaded) {
        schema.extend('imageBlock', {
          allowAttributes: 'imageStyle'
        }); // Converter for figure element from view to model.

        editor.data.upcastDispatcher.on('element:figure', viewToModelConverter, {
          priority: 'low'
        });
      }

      if (isInlinePluginLoaded) {
        schema.extend('imageInline', {
          allowAttributes: 'imageStyle'
        }); // Converter for the img element from view to model.

        editor.data.upcastDispatcher.on('element:img', viewToModelConverter, {
          priority: 'low'
        });
      }
    }
    /**
     * Registers a post-fixer that will make sure that the style attribute value is correct for a specific image type (block vs inline).
     *
     * @private
     */

  }, {
    key: "_setupPostFixer",
    value: function _setupPostFixer() {
      var editor = this.editor;
      var document = editor.model.document;
      var imageUtils = editor.plugins.get(ImageUtils);
      var stylesMap = new Map(this.normalizedStyles.map(function (style) {
        return [style.name, style];
      })); // Make sure that style attribute is valid for the image type.

      document.registerPostFixer(function (writer) {
        var changed = false;

        var _iterator = _createForOfIteratorHelper(document.differ.getChanges()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var change = _step.value;

            if (change.type == 'insert' || change.type == 'attribute' && change.attributeKey == 'imageStyle') {
              var element = change.type == 'insert' ? change.position.nodeAfter : change.range.start.nodeAfter;

              if (element && element.is('element', 'paragraph') && element.childCount > 0) {
                element = element.getChild(0);
              }

              if (!imageUtils.isImage(element)) {
                continue;
              }

              var imageStyle = element.getAttribute('imageStyle');

              if (!imageStyle) {
                continue;
              }

              var imageStyleDefinition = stylesMap.get(imageStyle);

              if (!imageStyleDefinition || !imageStyleDefinition.modelElements.includes(element.name)) {
                writer.removeAttribute('imageStyle', element);
                changed = true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return changed;
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ImageStyleEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [ImageUtils];
    }
  }]);

  return ImageStyleEditing;
}(Plugin);

export { ImageStyleEditing as default };